import {
    UPDATE_PROFILE,
    UPDATE_PROFILE_FAILURE,
    UPDATE_PROFILE_SUCCESS,

    UPDATE_PROFILE_PASSWORD,
    UPDATE_PROFILE_PASSWORD_FAILURE,
    UPDATE_PROFILE_PASSWORD_SUCCESS,
} from 'store/actions/types';
import authHelper from 'helpers/auth';

export const updateProfile = (payload) => {
    return {
        type: UPDATE_PROFILE,
        payload: payload,
    };
};

export const updateProfileFailure = (error) => {
    return {
        type: UPDATE_PROFILE_FAILURE,
        error: error,
    };
};

export const updateProfileSuccess = (response) => {
    authHelper.setUser(response);

    return {
        type: UPDATE_PROFILE_SUCCESS,
        response: response,
    };
};

export const updateProfilePassword = (payload) => {
    return {
        type: UPDATE_PROFILE_PASSWORD,
        payload: payload,
    };
};

export const updateProfilePasswordFailure = (error) => {
    return {
        type: UPDATE_PROFILE_PASSWORD_FAILURE,
        error: error,
    };
};

export const updateProfilePasswordSuccess = (response) => {
    authHelper.setUser(response);

    return {
        type: UPDATE_PROFILE_PASSWORD_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/updateProfile.js